document.addEventListener("DOMContentLoaded", async () => {
    // ==========================
    // DOM
    // ==========================
    const sucursalSelect = document.getElementById("sucursal");
    const sucursalCardsContainer = document.getElementById("sucursalCards");
    const staffSelect = document.getElementById("staff");
    const fechaInput = document.getElementById("fecha");
    const horariosDiv = document.getElementById("horarios");
    const confirmarBtn = document.getElementById("confirmarCita");

    const emailInput = document.getElementById("email");
    const firstNameInput = document.getElementById("first_name");
    const lastNameInput = document.getElementById("last_name");
    const phoneInput = document.getElementById("phone");

    const trainingTypeSelect = document.getElementById("training_type");
    const trainingCards = document.getElementById("trainingCards");
    const spaceTypeDiv = document.getElementById("space_type_div");

    const addGuest = document.getElementById("addGuest");
    const guestForm = document.getElementById("guestForm");
    const guestStaffSelect = document.getElementById("guest_staff");
    const guestHorarios = document.getElementById("guestHorarios");

    const popup = document.getElementById("popupConfirmacion");
    const popupAceptar = document.getElementById("popupAceptar");

    const stepEls = document.querySelectorAll(".step[data-step]");
    const nextBtns = document.querySelectorAll("[data-next]");
    const backBtns = document.querySelectorAll("[data-back]");
    const stepperBar = document.getElementById("stepperBar");

    // ==========================
    // Config
    // ==========================
    const duracionBase = 45;
    const duracionPorBooster = 15;

    const API_BASE = "https://pern-subscription-production.up.railway.app";
    const TZ = "America/Mexico_City";

    let spaceTypeSelect = null;
    let ultimaCita = null;

    let currentStep = 1;

    let staffCache = [];
    let selectedSlot = null;

    // ==========================
    // Helpers boosters
    // ==========================
    function obtenerBoosterSeleccionado() {
        const selected = document.querySelector(".booster.is-selected");
        if (!selected) return null;
        const name = selected.dataset.name;
        return name === "Sin booster" ? null : name;
    }

    function obtenerBoostersDetalle() {
        const name = obtenerBoosterSeleccionado();
        return name ? { [name]: 1 } : {};
    }

    function obtenerTotalBoosters() {
        return obtenerBoosterSeleccionado() ? 1 : 0;
    }

    function duracionTotalMin() {
        const totalBoosters = obtenerTotalBoosters();
        return duracionBase + totalBoosters * duracionPorBooster;
    }

    // ==========================
    // Helpers fecha/hora CDMX
    // ==========================
    function formatHHMMInCDMX(isoString) {
        const date = new Date(isoString);

        date.setHours(date.getHours() + 6);

        return date.toLocaleTimeString("es-MX", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    }

    // The API returns slot times where the UTC hour equals the CDMX local hour.
    // To save correctly we must shift +6h so the backend stores the right UTC time.
    function toAPITime(isoString) {
        return new Date(
            new Date(isoString).getTime() + 6 * 60 * 60_000,
        ).toISOString();
    }

    // ==========================
    // Inline validation helpers
    // ==========================
    function showError(errorId, inputId, msg) {
        const errEl = document.getElementById(errorId);
        if (errEl) errEl.textContent = msg;
        if (inputId)
            document.getElementById(inputId)?.classList.add("is-error");
    }

    function clearError(errorId, inputId) {
        const errEl = document.getElementById(errorId);
        if (errEl) errEl.textContent = "";
        if (inputId)
            document.getElementById(inputId)?.classList.remove("is-error");
    }

    // Prevent selecting past dates
    fechaInput.min = new Date().toISOString().split("T")[0];

    // ==========================
    // Stepper
    // ==========================
    function setStep(n) {
        currentStep = n;

        stepEls.forEach((el) => {
            el.classList.toggle("is-active", Number(el.dataset.step) === n);
        });

        if (stepperBar) {
            const pct = ((n - 1) / (stepEls.length - 1)) * 100;
            stepperBar.style.width = `${pct}%`;
        }

        const mobileLabel = document.getElementById("stepperMobileLabel");
        if (mobileLabel)
            mobileLabel.textContent = `Paso ${n} de ${stepEls.length}`;

        if (n === 4) {
            maybeLoadStaffAndHorarios();
        }

        if (n === 5) {
            refreshConfirmBtn();
        }
    }

    function validateStep(step) {
        if (step === 1) {
            if (!sucursalSelect?.value) {
                showError(
                    "error-sucursal",
                    "sucursal",
                    "Selecciona un estudio.",
                );
                return false;
            }
            clearError("error-sucursal", "sucursal");
            return true;
        }

        if (step === 2) {
            if (!trainingTypeSelect?.value) {
                showError(
                    "error-training",
                    null,
                    "Selecciona el tipo de entrenamiento.",
                );
                return false;
            }
            clearError("error-training", null);
            return true;
        }

        if (step === 3) {
            return true;
        }

        if (step === 4) {
            let valid = true;
            if (!fechaInput?.value) {
                showError("error-fecha", "fecha", "Selecciona una fecha.");
                valid = false;
            } else {
                clearError("error-fecha", "fecha");
            }
            if (!staffSelect?.value) {
                showError("error-staff", "staff", "Selecciona un staff.");
                valid = false;
            } else {
                clearError("error-staff", "staff");
            }
            if (!selectedSlot?.startISO) {
                showError(
                    "error-slot",
                    null,
                    "Selecciona un horario disponible.",
                );
                valid = false;
            } else {
                clearError("error-slot", null);
            }
            return valid;
        }

        if (step === 5) {
            let valid = true;
            if (!emailInput?.value.trim()) {
                showError("error-email", "email", "Escribe tu correo.");
                valid = false;
            } else {
                clearError("error-email", "email");
            }
            if (!firstNameInput?.value.trim()) {
                showError(
                    "error-first-name",
                    "first_name",
                    "Escribe tu nombre.",
                );
                valid = false;
            } else {
                clearError("error-first-name", "first_name");
            }
            if (!lastNameInput?.value.trim()) {
                showError(
                    "error-last-name",
                    "last_name",
                    "Escribe tu apellido.",
                );
                valid = false;
            } else {
                clearError("error-last-name", "last_name");
            }
            if (!phoneInput?.value.trim()) {
                showError("error-phone", "phone", "Escribe tu teléfono.");
                valid = false;
            } else {
                clearError("error-phone", "phone");
            }
            return valid;
        }

        return true;
    }

    function nextStep() {
        if (!validateStep(currentStep)) return;
        setStep(Math.min(currentStep + 1, stepEls.length));
        document
            .getElementById("agendarStepper")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function prevStep() {
        setStep(Math.max(currentStep - 1, 1));
    }

    function fadeToNextStep() {
        const currentEl = document.querySelector(
            `.step[data-step="${currentStep}"]`,
        );
        if (!currentEl) return nextStep();

        if (currentEl.dataset.locked === "true") return;
        currentEl.dataset.locked = "true";

        currentEl.classList.add("is-fading-out");

        setTimeout(() => {
            currentEl.classList.remove("is-fading-out");
            currentEl.dataset.locked = "false";
            nextStep();
        }, 220);
    }

    nextBtns.forEach((b) => b.addEventListener("click", nextStep));
    backBtns.forEach((b) => b.addEventListener("click", prevStep));

    // ==========================
    // Carga sucursales
    // ==========================

    function renderSucursalCards(branches) {
        if (!sucursalCardsContainer) return;
        sucursalCardsContainer.innerHTML = "";

        const images = window.FACER_SUCURSAL_IMAGES || {};

        (branches || []).forEach((b) => {
            const card = document.createElement("button");
            card.type = "button";
            card.className = "sucursal-card";
            card.dataset.id = String(b.id);
            card.setAttribute("role", "radio");
            card.setAttribute("aria-checked", "false");

            const media = document.createElement("div");
            media.className = "sucursal-card__media";
            const imgUrl = images[b.id];
            if (imgUrl) {
                const img = document.createElement("img");
                img.src = imgUrl;
                img.alt = b.name || "";
                img.loading = "lazy";
                media.appendChild(img);
            } else {
                const placeholder = document.createElement("span");
                placeholder.className = "sucursal-card__placeholder";
                placeholder.textContent = (b.name || "")
                    .slice(0, 2)
                    .toUpperCase();
                media.appendChild(placeholder);
            }

            const check = document.createElement("span");
            check.className = "sucursal-card__check";
            check.setAttribute("aria-hidden", "true");
            check.textContent = "✓";
            media.appendChild(check);

            const body = document.createElement("div");
            body.className = "sucursal-card__body";

            const name = document.createElement("h3");
            name.textContent = b.name || "";

            const mapsLink = document.createElement("a");
            mapsLink.className = "sucursal-card__maps";
            mapsLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                b.address || b.name || "",
            )}`;
            mapsLink.target = "_blank";
            mapsLink.rel = "noopener";
            mapsLink.textContent = "Como llegar";
            mapsLink.addEventListener("click", (e) => e.stopPropagation());

            body.appendChild(name);
            body.appendChild(mapsLink);

            card.appendChild(media);
            card.appendChild(body);

            card.addEventListener("click", () => {
                sucursalSelect.value = String(b.id);
                sucursalSelect.dispatchEvent(
                    new Event("change", { bubbles: true }),
                );

                sucursalCardsContainer
                    .querySelectorAll(".sucursal-card")
                    .forEach((el) => {
                        el.classList.remove("is-selected");
                        el.setAttribute("aria-checked", "false");
                    });
                card.classList.add("is-selected");
                card.setAttribute("aria-checked", "true");
            });

            sucursalCardsContainer.appendChild(card);
        });
    }

    try {
        const res = await fetch(`${API_BASE}/api/branches`);
        const branches = await res.json();

        sucursalSelect.innerHTML =
            '<option value="">Selecciona un estudio</option>';

        (branches || []).forEach((b) => {
            const opt = document.createElement("option");
            opt.value = b.id;
            opt.textContent = b.name;
            sucursalSelect.appendChild(opt);
        });

        renderSucursalCards(branches);
    } catch (err) {
        console.error("Error cargando sucursales", err);
        if (sucursalCardsContainer) {
            sucursalCardsContainer.innerHTML = "";
            const msg = document.createElement("p");
            msg.className = "sucursal-cards-error";
            msg.textContent =
                "No pudimos cargar las sucursales. Intenta recargar la página.";
            sucursalCardsContainer.appendChild(msg);
        }
    }

    // ==========================
    // Auto-advance triggers
    // ==========================

    // Actualiza precios según sucursal
    function updatePrices(isTorreon) {
        document.querySelectorAll(".training-price").forEach((el) => {
            el.innerHTML = "";

            const main = document.createElement("span");
            main.className = "training-price__main";
            main.textContent = isTorreon
                ? el.dataset.priceTorreon
                : el.dataset.priceGeneral;
            el.appendChild(main);

            if (!isTorreon && el.dataset.priceMember) {
                const member = document.createElement("span");
                member.className = "training-price__member";
                member.textContent = el.dataset.priceMember;
                el.appendChild(member);
            }
        });

        document.querySelectorAll(".booster-price").forEach((el) => {
            el.innerHTML = "";

            const main = document.createElement("span");
            main.className = "booster-price__main";
            main.textContent = isTorreon
                ? el.dataset.priceTorreon
                : el.dataset.priceGeneral;
            el.appendChild(main);

            if (!isTorreon && el.dataset.priceMember) {
                const member = document.createElement("span");
                member.className = "booster-price__member";
                member.textContent = el.dataset.priceMember;
                el.appendChild(member);
            }
        });
    }

    // Step 1 => sucursal
    sucursalSelect.addEventListener("change", async () => {
        const id = sucursalSelect.value;
        if (!id) return;

        const selectedText = (
            sucursalSelect.options[sucursalSelect.selectedIndex]?.text || ""
        )
            .toLowerCase()
            .normalize("NFD")
            .replace(/[̀-ͯ]/g, "");
        const isTorreon = selectedText.indexOf("torreon") !== -1;
        updatePrices(isTorreon);

        resetHorarioSelection();

        try {
            await loadStaffByBranch(id);
        } catch (err) {
            console.error("Error staff", err);
        }

        if (currentStep === 1 && sucursalSelect.value) {
            fadeToNextStep();
        }

        if (currentStep >= 4 && fechaInput.value && staffSelect.value) {
            await cargarHorarios();
        }
    });

    // Step 2 => training type
    if (trainingCards && trainingTypeSelect) {
        trainingCards.addEventListener("click", (e) => {
            const card = e.target.closest(".training-card");
            if (!card) return;

            const value = card.dataset.value;
            if (!value) return;

            trainingCards.querySelectorAll(".training-card").forEach((c) => {
                c.classList.remove("is-selected");
                c.setAttribute("aria-pressed", "false");
            });

            card.classList.add("is-selected");
            card.setAttribute("aria-pressed", "true");

            trainingTypeSelect.value = value;

            if (currentStep === 2) {
                fadeToNextStep();
            }
        });
    }

    // ==========================
    // Email blur => tipo de espacio
    // ==========================
    if (emailInput) {
        emailInput.addEventListener("blur", async () => {
            const email = emailInput.value.trim();
            if (!email) return;

            try {
                const res = await fetch(
                    `${API_BASE}/api/subscription/by-email/${email}`,
                );
                const sub = await res.json();

                if (sub && sub.id) {
                    spaceTypeDiv.innerHTML = `
                        <label>Tipo de espacio</label>
                        <select id="space_type">
                            <option value="public">Público</option>
                            <option value="private">Privado</option>
                        </select>
                    `;
                    spaceTypeSelect = document.getElementById("space_type");
                } else {
                    spaceTypeDiv.innerHTML = "";
                    spaceTypeSelect = null;
                }
            } catch {
                spaceTypeDiv.innerHTML = "";
                spaceTypeSelect = null;
            }

            refreshConfirmBtn();
        });
    }

    // ==========================
    // Staff por sucursal
    // ==========================
    async function loadStaffByBranch(branchId) {
        staffSelect.disabled = true;
        staffSelect.innerHTML = "<option>Cargando...</option>";

        if (guestStaffSelect) {
            guestStaffSelect.disabled = true;
            guestStaffSelect.innerHTML = "<option>Cargando...</option>";
        }

        try {
            const res = await fetch(`${API_BASE}/api/staff/${branchId}`);
            const staff = res.ok ? await res.json() : [];
            staffCache = Array.isArray(staff) ? staff : [];
        } catch (err) {
            console.error("Error cargando staff", err);
            staffCache = [];
        }

        staffSelect.innerHTML = `
            <option value="">Selecciona un staff</option>
            <option value="any">Cualquier miembro del staff</option>
        `;

        if (guestStaffSelect) {
            guestStaffSelect.innerHTML = `<option value="">Selecciona un staff</option>`;
        }

        staffCache.forEach((s) => {
            const o1 = document.createElement("option");
            o1.value = s.id;
            o1.textContent = s.name;
            staffSelect.appendChild(o1);

            if (guestStaffSelect) {
                const o2 = o1.cloneNode(true);
                guestStaffSelect.appendChild(o2);
            }
        });

        staffSelect.disabled = false;
        if (guestStaffSelect) guestStaffSelect.disabled = false;
    }

    // ==========================
    // Horarios
    // ==========================
    function resetHorarioSelection() {
        selectedSlot = null;
        horariosDiv.innerHTML = "";
        confirmarBtn.disabled = true;
        confirmarBtn.dataset.horaISO = "";
        confirmarBtn.dataset.staffIdReal = "";
        confirmarBtn.dataset.staffNameReal = "";
    }
    async function fetchSlotsForStaff(
        staffId,
        fecha,
        duracionTotal,
        totalBoosters,
        branchId,
    ) {
        const url = `${API_BASE}/api/staff/${staffId}/available-slots?start_date=${fecha}&end_date=${fecha}&duration=${duracionTotal}&boosters=${totalBoosters}&branch_id=${branchId}`;
        const res = await fetch(url);
        if (!res.ok) return [];
        const data = await res.json();
        return (data.events || []).filter((e) => e.available === true);
    }

    async function cargarHorarios() {
        const staffId = staffSelect.value;
        const fecha = fechaInput.value;
        if (!staffId || !fecha) return;

        resetHorarioSelection();
        horariosDiv.innerHTML = "Cargando...";

        try {
            const totalBoosters = obtenerTotalBoosters();
            const duracionTotal = duracionTotalMin();

            let slots = [];

            if (staffId === "any") {
                if (!staffCache.length) {
                    horariosDiv.innerHTML =
                        "<p>Primero selecciona un estudio.</p>";
                    return;
                }

                const results = await Promise.allSettled(
                    staffCache.map(async (s) => {
                        const evs = await fetchSlotsForStaff(
                            s.id,
                            fecha,
                            duracionTotal,
                            totalBoosters,
                            sucursalSelect.value,
                        );
                        return evs.map((ev) => ({
                            start: ev.start,
                            end: ev.end,
                            staffId: s.id,
                            staffName: s.name,
                        }));
                    }),
                );

                slots = results
                    .filter((r) => r.status === "fulfilled")
                    .flatMap((r) => r.value);
            } else {
                const evs = await fetchSlotsForStaff(
                    staffId,
                    fecha,
                    duracionTotal,
                    totalBoosters,
                    sucursalSelect.value,
                );
                const staffName =
                    staffSelect.options[staffSelect.selectedIndex]?.text || "";
                slots = evs.map((ev) => ({
                    start: ev.start,
                    end: ev.end,
                    staffId,
                    staffName,
                }));
            }

            slots.sort((a, b) => new Date(a.start) - new Date(b.start));

            horariosDiv.innerHTML = "";

            if (!slots.length) {
                horariosDiv.innerHTML =
                    '<p class="no-slots-msg">Sin horarios disponibles para esta fecha. Prueba con otra fecha o reduce el número de boosters.</p>';
                return;
            }

            slots.forEach((s) => {
                const btn = document.createElement("button");

                const labelHora = formatHHMMInCDMX(s.start);
                const labelStaff = staffId === "any" ? ` (${s.staffName})` : "";
                btn.textContent = `${labelHora}${labelStaff}`;

                btn.onclick = () => {
                    document
                        .querySelectorAll("#horarios button")
                        .forEach((b) => b.classList.remove("selected"));

                    btn.classList.add("selected");

                    selectedSlot = {
                        startISO: s.start,
                        staffId: s.staffId,
                        staffName: s.staffName,
                    };

                    clearError("error-slot", null);
                    confirmarBtn.dataset.horaISO = s.start;
                    confirmarBtn.dataset.staffIdReal = String(s.staffId || "");
                    confirmarBtn.dataset.staffNameReal = String(
                        s.staffName || "",
                    );

                    refreshConfirmBtn();
                    onMainSlotChanged();

                    if (currentStep === 4 && !addGuest?.checked) {
                        fadeToNextStep();
                    }
                };

                horariosDiv.appendChild(btn);
            });
        } catch (e) {
            console.error(e);
            horariosDiv.innerHTML = "Error cargando horarios";
        }
    }

    function maybeLoadStaffAndHorarios() {
        if (!sucursalSelect.value) return;

        if (staffSelect.disabled || staffSelect.options.length <= 1) {
            loadStaffByBranch(sucursalSelect.value)
                .then(() => {
                    if (fechaInput.value && staffSelect.value) cargarHorarios();
                })
                .catch(console.error);
            return;
        }

        if (fechaInput.value && staffSelect.value) cargarHorarios();
    }

    // ==========================
    // Eventos step 4
    // ==========================
    staffSelect.addEventListener("change", () => {
        resetHorarioSelection();
        cargarHorarios();
    });

    fechaInput.addEventListener("change", () => {
        resetHorarioSelection();
        cargarHorarios();
    });

    // ==========================
    // Boosters
    // ==========================
    const boostersContainer = document.getElementById("boosters");
    if (boostersContainer) {
        boostersContainer.addEventListener("click", (e) => {
            const card = e.target.closest(".booster");
            if (!card) return;

            boostersContainer.querySelectorAll(".booster").forEach((c) => {
                c.classList.remove("is-selected");
                c.setAttribute("aria-pressed", "false");
            });

            card.classList.add("is-selected");
            card.setAttribute("aria-pressed", "true");

            if (currentStep === 3) {
                fadeToNextStep();
            }
        });
    }

    // ==========================
    // Guest toggle + scheduling
    // ==========================

    // Extra DOM refs for guest scheduling
    const guestSchedulingSection = document.getElementById(
        "guestSchedulingSection",
    );
    const guestHorariosLabel = document.getElementById("guestHorariosLabel");
    const guestHorariosMsg = document.getElementById("guestHorariosMsg");

    // Slot selected for guest
    let guestSelectedSlot = null;

    function branchHasMultipleStaff() {
        return staffCache.length > 1;
    }

    function renderSlotButtons(container, slots, onSelect, currentSelected) {
        container.innerHTML = "";
        if (!slots.length) {
            container.innerHTML = "<p>Sin horarios disponibles</p>";
            return;
        }
        slots.forEach((s) => {
            const btn = document.createElement("button");
            btn.type = "button";
            const labelHora = formatHHMMInCDMX(s.start);
            const labelStaff = s.staffName ? ` (${s.staffName})` : "";
            btn.textContent = `${labelHora}${labelStaff}`;

            if (
                currentSelected &&
                currentSelected.startISO === s.start &&
                String(currentSelected.staffId) === String(s.staffId)
            ) {
                btn.classList.add("selected");
            }

            btn.onclick = () => {
                container
                    .querySelectorAll("button")
                    .forEach((b) => b.classList.remove("selected"));
                btn.classList.add("selected");
                onSelect({
                    startISO: s.start,
                    staffId: s.staffId,
                    staffName: s.staffName,
                });
                refreshConfirmBtn();
            };
            container.appendChild(btn);
        });
    }

    async function cargarGuestHorarios() {
        if (!selectedSlot?.startISO) return;
        if (!fechaInput.value) return;

        guestHorarios.innerHTML = "Cargando...";
        guestHorariosMsg.textContent = "";
        guestSelectedSlot = null;
        refreshConfirmBtn();

        const fecha = fechaInput.value;
        const totalBoosters = obtenerTotalBoosters();
        const duracionTotal = duracionTotalMin();
        const mainStaffId = String(selectedSlot.staffId);

        try {
            if (branchHasMultipleStaff()) {
                // Multi-staff: fetch slots for every staff EXCEPT the main one
                const otherStaff = staffCache.filter(
                    (s) => String(s.id) !== mainStaffId,
                );

                const results = await Promise.allSettled(
                    otherStaff.map(async (s) => {
                        const evs = await fetchSlotsForStaff(
                            s.id,
                            fecha,
                            duracionTotal,
                            totalBoosters,
                            sucursalSelect.value,
                        );
                        return evs.map((ev) => ({
                            start: ev.start,
                            end: ev.end,
                            staffId: s.id,
                            staffName: s.name,
                        }));
                    }),
                );

                const twoHours = 2 * 60 * 60_000;
                const mainStartMs = new Date(selectedSlot.startISO).getTime();
                const slots = results
                    .filter((r) => r.status === "fulfilled")
                    .flatMap((r) => r.value)
                    .filter(
                        (s) =>
                            Math.abs(
                                new Date(s.start).getTime() - mainStartMs,
                            ) <= twoHours,
                    )
                    .sort((a, b) => new Date(a.start) - new Date(b.start));

                guestHorariosLabel.style.display = "block";
                guestHorariosMsg.textContent =
                    "Horarios disponibles con los otros trainers en la misma sucursal (±2 horas de tu cita).";

                renderSlotButtons(
                    guestHorarios,
                    slots,
                    (slot) => {
                        guestSelectedSlot = slot;
                    },
                    guestSelectedSlot,
                );
            } else {
                // Single-staff: same staff, slots closest in time to the main appointment
                // Si el usuario eligió "any", usar el staff real asignado al slot principal
                const resolvedStaffId =
                    mainStaffId === "any"
                        ? confirmarBtn.dataset.staffIdReal || staffCache[0]?.id
                        : staffCache[0]?.id || mainStaffId;
                const resolvedStaffName =
                    confirmarBtn.dataset.staffNameReal ||
                    staffCache[0]?.name ||
                    selectedSlot.staffName;
                const evs = await fetchSlotsForStaff(
                    resolvedStaffId,
                    fecha,
                    duracionTotal,
                    totalBoosters,
                    sucursalSelect.value,
                );

                const mainStart = new Date(selectedSlot.startISO).getTime();
                const mainEnd = mainStart + duracionTotal * 60_000;

                const validSlots = evs
                    .map((ev) => ({
                        start: ev.start,
                        end: ev.end,
                        staffId: resolvedStaffId,
                        staffName: resolvedStaffName,
                    }))
                    .filter((s) => {
                        const sStart = new Date(s.start).getTime();
                        const sEnd = sStart + duracionTotal * 60_000;
                        const twoHours = 2 * 60 * 60_000;
                        const noOverlap =
                            sEnd <= mainStart || sStart >= mainEnd;
                        const withinWindow =
                            Math.abs(sStart - mainStart) <= twoHours;
                        return noOverlap && withinWindow;
                    });

                validSlots.sort(
                    (a, b) =>
                        Math.abs(new Date(a.start).getTime() - mainStart) -
                        Math.abs(new Date(b.start).getTime() - mainStart),
                );

                guestHorariosLabel.style.display = "block";
                guestHorariosMsg.textContent =
                    "Esta sucursal tiene un solo trainer; el acompañante debe ir antes o después de tu cita (±2 horas).";

                renderSlotButtons(
                    guestHorarios,
                    validSlots,
                    (slot) => {
                        guestSelectedSlot = slot;
                    },
                    guestSelectedSlot,
                );
            }
        } catch (e) {
            console.error(e);
            guestHorarios.innerHTML =
                "<p>Error cargando horarios para el acompañante.</p>";
        }
    }

    if (addGuest && guestForm) {
        addGuest.addEventListener("change", async () => {
            const checked = addGuest.checked;
            guestForm.style.display = checked ? "block" : "none";

            if (checked && selectedSlot?.startISO) {
                guestSchedulingSection.style.display = "block";
                await cargarGuestHorarios();
            } else if (!checked) {
                guestSelectedSlot = null;
                guestSchedulingSection.style.display = "none";
                guestHorarios.innerHTML = "";
                guestHorariosLabel.style.display = "none";
                guestHorariosMsg.textContent = "";
                refreshConfirmBtn();
            }
        });
    }

    function onMainSlotChanged() {
        if (addGuest?.checked && guestForm?.style.display !== "none") {
            guestSchedulingSection.style.display = "block";
            cargarGuestHorarios();
        }
    }

    // ==========================
    // Confirm enable logic
    // ==========================
    function refreshConfirmBtn() {
        const hasSlot = !!selectedSlot?.startISO;
        const hasEmail = !!(emailInput?.value || "").trim();
        const hasFirst = !!(firstNameInput?.value || "").trim();
        const hasLast = !!(lastNameInput?.value || "").trim();
        const hasPhone = !!(phoneInput?.value || "").trim();
        const hasClient = hasEmail && hasFirst && hasLast && hasPhone;

        confirmarBtn.disabled = !(hasSlot && hasClient);

        const hint = document.getElementById("confirmarHint");
        if (!hint) return;
        if (confirmarBtn.disabled) {
            const missing = [];
            if (!hasSlot) missing.push("horario");
            if (!hasEmail) missing.push("correo");
            if (!hasFirst) missing.push("nombre");
            if (!hasLast) missing.push("apellido");
            if (!hasPhone) missing.push("teléfono");
            hint.textContent = `Completa: ${missing.join(", ")}`;
        } else {
            hint.textContent = "";
        }
    }

    [emailInput, firstNameInput, lastNameInput, phoneInput].forEach((el) => {
        if (!el) return;
        el.addEventListener("input", refreshConfirmBtn);
    });

    // Clear inline errors when user corrects a field
    sucursalSelect.addEventListener("change", () =>
        clearError("error-sucursal", "sucursal"),
    );
    fechaInput.addEventListener("change", () =>
        clearError("error-fecha", "fecha"),
    );
    staffSelect.addEventListener("change", () =>
        clearError("error-staff", "staff"),
    );
    emailInput?.addEventListener("input", () =>
        clearError("error-email", "email"),
    );
    firstNameInput?.addEventListener("input", () =>
        clearError("error-first-name", "first_name"),
    );
    lastNameInput?.addEventListener("input", () =>
        clearError("error-last-name", "last_name"),
    );
    phoneInput?.addEventListener("input", () =>
        clearError("error-phone", "phone"),
    );

    // ==========================
    // Calendar links
    // ==========================
    function buildCalendarLinks(cita, duracionMin) {
        const pad = (n) => String(n).padStart(2, "0");
        const fmt = (d) =>
            `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

        const startUTC = new Date(toAPITime(cita.horaISO));
        const endUTC = new Date(startUTC.getTime() + duracionMin * 60_000);

        const boostersStr = Object.keys(cita.boosters).length
            ? Object.entries(cita.boosters)
                  .map(([k, v]) => `${k} (${v})`)
                  .join(", ")
            : "Sin boosters";

        const text = encodeURIComponent(
            `Entrenamiento FACER - ${cita.training}`,
        );
        const details = encodeURIComponent(
            `Trainer: ${cita.staff}\nBoosters: ${boostersStr}`,
        );
        const location = encodeURIComponent(cita.sucursal);

        const googleURL = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${fmt(startUTC)}/${fmt(endUTC)}&details=${details}&location=${location}`;

        const icsLines = [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "PRODID:-//FACER//Cita//ES",
            "BEGIN:VEVENT",
            `DTSTART:${fmt(startUTC)}`,
            `DTEND:${fmt(endUTC)}`,
            `SUMMARY:Entrenamiento FACER - ${cita.training}`,
            `DESCRIPTION:Trainer: ${cita.staff}\\nBoosters: ${boostersStr}`,
            `LOCATION:${cita.sucursal}`,
            "STATUS:CONFIRMED",
            "END:VEVENT",
            "END:VCALENDAR",
        ].join("\r\n");

        return {
            googleURL,
            icsURI:
                "data:text/calendar;charset=utf8," +
                encodeURIComponent(icsLines),
        };
    }

    // ==========================
    // Confirmar cita
    // ==========================
    confirmarBtn.addEventListener("click", async () => {
        if (!validateStep(5)) return;

        // Block button and show spinner
        confirmarBtn.disabled = true;
        confirmarBtn.dataset.originalText = confirmarBtn.textContent;
        confirmarBtn.innerHTML =
            '<span class="btn-spinner"></span> Confirmando...';

        const horaISO = confirmarBtn.dataset.horaISO;
        const boostersDetalle = obtenerBoostersDetalle();
        const duracionTotal = duracionTotalMin();

        const start = new Date(horaISO);
        const end = new Date(start.getTime() + duracionTotal * 60000);

        const staffIdFinal =
            staffSelect.value === "any"
                ? confirmarBtn.dataset.staffIdReal
                : staffSelect.value;

        const cita = {
            email: emailInput.value,
            first_name: firstNameInput.value,
            last_name: lastNameInput.value,
            phone: phoneInput.value,
            branch_id: sucursalSelect.value,
            staff_id: staffIdFinal,
            service_name: "ENTRENAR",
            start_time: start.toISOString(),
            end_time: end.toISOString(),
            status: "RESERVADA",
            space_type: spaceTypeSelect ? spaceTypeSelect.value : "public",
            notes: {
                training_type: trainingTypeSelect.value,
                boosters: boostersDetalle,
            },
            source: "SHOPIFY",
        };

        console.log(cita);

        const staffNameFinal =
            staffSelect.value === "any"
                ? confirmarBtn.dataset.staffNameReal || "Staff asignado"
                : staffSelect.options[staffSelect.selectedIndex]?.text;

        ultimaCita = {
            email: emailInput.value,
            nombre: `${firstNameInput.value} ${lastNameInput.value}`,
            telefono: phoneInput.value,
            sucursal:
                sucursalSelect.options[sucursalSelect.selectedIndex]?.text,
            staff: staffNameFinal,
            fecha: fechaInput.value,
            horaISO: horaISO,
            training: trainingTypeSelect.value,
            boosters: boostersDetalle,
        };

        try {
            const parsePrice = (text) => {
                const num = parseFloat((text || "").replace(/[^0-9.]/g, ""));
                return Number.isNaN(num) ? 0 : num;
            };
            const trainingPriceText =
                document.querySelector(
                    ".training-card.is-selected .training-price__main",
                )?.textContent;
            const boosterPriceText =
                document.querySelector(
                    ".booster.is-selected .booster-price__main",
                )?.textContent;
            const value =
                parsePrice(trainingPriceText) + parsePrice(boosterPriceText);
            const guestEmailTrack = document
                .getElementById("guest_email")
                ?.value?.trim();

            window.Shopify?.analytics?.publish("facer_cita_agendada", {
                event_id: `cita_${Date.now()}_${Math.random()
                    .toString(36)
                    .slice(2)}`,
                value,
                currency: "MXN",
                sucursal: ultimaCita.sucursal,
                training: ultimaCita.training,
                booster: obtenerBoosterSeleccionado() || "Sin booster",
                con_acompanante: !!(
                    addGuest?.checked &&
                    guestEmailTrack &&
                    guestSelectedSlot?.startISO
                ),
                email: ultimaCita.email,
                phone: ultimaCita.telefono,
            });
        } catch (err) {
            console.warn("Error al publicar evento de tracking", err);
        }

        try {
            const res = await fetch(`${API_BASE}/api/appointments`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(cita),
            });

            if (!res.ok) throw new Error();

            // ── Guest appointment ──────────────────────────────────────
            const guestEmail = document
                .getElementById("guest_email")
                ?.value?.trim();
            const guestFirstName = document
                .getElementById("guest_first_name")
                ?.value?.trim();
            const guestLastName = document
                .getElementById("guest_last_name")
                ?.value?.trim();
            const guestPhone = document
                .getElementById("guest_phone")
                ?.value?.trim();
            const hasGuest =
                addGuest?.checked &&
                guestEmail &&
                guestFirstName &&
                guestSelectedSlot?.startISO;

            let guestCitaResumen = null;

            if (hasGuest) {
                const guestStart = new Date(guestSelectedSlot.startISO);
                const guestEnd = new Date(
                    guestStart.getTime() + duracionTotal * 60000,
                );

                const guestCita = {
                    email: guestEmail,
                    first_name: guestFirstName,
                    last_name: guestLastName || "",
                    phone: guestPhone || "",
                    branch_id: sucursalSelect.value,
                    staff_id: String(guestSelectedSlot.staffId),
                    service_name: "ENTRENAR",
                    start_time: guestStart.toISOString(),
                    end_time: guestEnd.toISOString(),
                    status: "RESERVADA",
                    space_type: spaceTypeSelect
                        ? spaceTypeSelect.value
                        : "public",
                    notes: {
                        training_type: trainingTypeSelect.value,
                        boosters: boostersDetalle,
                        guest_of: emailInput.value,
                    },
                    source: "SHOPIFY",
                };

                try {
                    const guestRes = await fetch(
                        `${API_BASE}/api/appointments`,
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(guestCita),
                        },
                    );

                    if (guestRes.ok) {
                        guestCitaResumen = {
                            nombre: `${guestFirstName} ${guestLastName || ""}`.trim(),
                            staff:
                                guestSelectedSlot.staffName || "Staff asignado",
                            horaISO: guestSelectedSlot.startISO,
                        };
                    }
                } catch {
                    console.warn("Error al crear cita del acompañante");
                }
            }
            // ───────────────────────────────────────────────────────────

            const resumenDiv = document.getElementById("resumenCita");

            const boostersTexto =
                Object.keys(ultimaCita.boosters).length > 0
                    ? Object.entries(ultimaCita.boosters)
                          .map(([k, v]) => `${k} (${v})`)
                          .join(", ")
                    : "Sin boosters";

            let guestHtml = "";
            if (guestCitaResumen) {
                guestHtml = `
                    <hr style="margin:12px 0; border:none; border-top:1px solid #eee;">
                    <p><strong>Acompañante:</strong> ${guestCitaResumen.nombre}</p>
                    <p><strong>Trainer:</strong> ${guestCitaResumen.staff}</p>
                    <p><strong>Hora acompañante:</strong> ${formatHHMMInCDMX(guestCitaResumen.horaISO)}</p>
                `;
            }

            resumenDiv.innerHTML = `
                <p><strong>Sucursal:</strong> ${ultimaCita.sucursal}</p>
                <p><strong>Fecha:</strong> ${ultimaCita.fecha}</p>
                <p><strong>Hora:</strong> ${formatHHMMInCDMX(ultimaCita.horaISO)}</p>
                <p><strong>Entrenamiento:</strong> ${ultimaCita.training}</p>
                <p><strong>Boosters:</strong> ${boostersTexto}</p>
                ${guestHtml}
            `;

            const { googleURL, icsURI } = buildCalendarLinks(
                ultimaCita,
                duracionTotal,
            );
            const googleCalLink = document.getElementById("googleCalLink");
            const icsLink = document.getElementById("icsLink");
            const calendarLinks = document.getElementById("calendarLinks");
            if (googleCalLink) googleCalLink.href = googleURL;
            if (icsLink) icsLink.href = icsURI;
            if (calendarLinks) calendarLinks.style.display = "block";

            popup.style.display = "flex";
        } catch {
            // Restore button on error so the user can retry
            confirmarBtn.disabled = false;
            confirmarBtn.textContent =
                confirmarBtn.dataset.originalText || "Confirmar cita";
            alert("Error al crear cita. Por favor intenta de nuevo.");
        }
    });

    popupAceptar.addEventListener("click", () => {
        window.location.href = "https://facer.mx/pages/gracias-por-agendar";
    });

    setStep(1);
});
